import { createSlice } from "@reduxjs/toolkit";
import { API_STATUSES } from "redux/_helpers/statuses";

const siteReducers = createSlice({
  name: "siteReducers",
  initialState: {
    getV4GraphicsSiteStatus: API_STATUSES.REQUEST,
    getV4GraphicsSiteData: [],
    setV3GraphicsSiteStatus: API_STATUSES.REQUEST,
    setV3GraphicsSiteData: []
  },

  reducers: {
    getV4GraphicsSiteStatus: (state, action) => {
      state.getV4GraphicsSiteStatus = action.payload;
    },
    getV4GraphicsSiteData: (state, action) => {
      state.getV4GraphicsSiteData = action.payload;
    },
    setV3GraphicsSiteStatus: (state, action) => {
      state.setV3GraphicsSiteStatus = action.payload;
    },
    setV3GraphicsSiteData: (state, action) => {
      state.setV3GraphicsSiteData = action.payload;
    }
  },
});

export const {
  getV4GraphicsSiteStatus,
  getV4GraphicsSiteData,
  setV3GraphicsSiteStatus,
  setV3GraphicsSiteData
} = siteReducers.actions;

export default siteReducers.reducer;
